<div class="filter-input-element">
  <nz-space>
    <nz-switch
      *nzSpaceItem
      [(ngModel)]="value"
      style="width: 100%"
      (ngModelChange)="onChange($event)"
      [nzCheckedChildren]="checkedTemplate"
      [nzUnCheckedChildren]="unCheckedTemplate"
    ></nz-switch>
    <ng-container *nzSpaceItem>
      <a *ngIf="value != null" (click)="value = null; onChange(null)">
        {{'Clear'  | translate}}
      </a>
    </ng-container>
  </nz-space>
  <ng-template #checkedTemplate
    ><span nz-icon nzType="check"></span
  ></ng-template>
  <ng-template #unCheckedTemplate
    ><span nz-icon nzType="close"></span
  ></ng-template>
</div>
